import styles from './ProgressBar.module.css'

export interface ProgressBarProps {
  value: number
  showLabel?: boolean
}

export function ProgressBar({ value, showLabel = false }: ProgressBarProps) {
  const done = value >= 100
  const width = Math.max(0, Math.min(value, 100))
  return (
    <>
      <div className={`${styles.bar} ${done ? styles.done : ''}`} role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={value}>
        <i className={styles.fill} style={{ width: `${width}%` }} />
      </div>
      {showLabel ? <p className={styles.foot}>完成 <strong>{value}%</strong></p> : null}
    </>
  )
}
